<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="提货券名称" name='voucher_name'>
          <a-input v-model:value="search.voucher_name" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="核销时间" name='time'>
          <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changTime" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <a-button class='m-r-10' v-has:pickUpStoreStaticsExport="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-40'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='member_id' :columns='columns' :data-source='list'>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { iscode } from "@/utils/app";
import {getStoreVoucherwriteoffListDetail,getStoreVoucherwriteoffListDetailExoprt} from '@/api/assets.js'
const def = {
  page: 1,
  limit: 10,
  key_type: "",
  keyword: "",
  dealer_name:'',
  store_name:'',
  voucher_name: "",
  start_time: "",
  end_time: "",
};
export default {
  components: {},
  name: "integralDetail",
  setup() {
    const state = reactive({
      listLoading: false,
      total: 0,
    });
    let list = ref();
    let columns = [
      {
        title: "码ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "卡券ID",
        dataIndex: "voucher_id",
        key: "voucher_id",
      },
      {
        title: "提货券名称",
        dataIndex: "voucher_name",
        key: "voucher_name",
      },
      {
        title: "核销内容",
        dataIndex: "preferential_content",
        key: "preferential_content",
      },
      {
        title: "核销时间",
        dataIndex: "create_time",
        key: "create_time",
      },
    ];
    // 
    const $route=inject('$route')
    //获取列表
    const initData = async (values) => {
      state.listLoading = true;
      let res = await getStoreVoucherwriteoffListDetail({
        store_id:$route.query.store_id,
        ...values,
      }).then((res) => res.data);
      if (iscode(res)) {
        list.value = res.data.data;
        state.total = res.data.total;
      }
      state.listLoading = false;
    };
    const $Modal = inject("$Modal");

    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };
    onMounted(() => {
      initData(search.value);
    });
    // 导出
    const exportTable = async () => {
      let res = await getStoreVoucherwriteoffListDetailExoprt({ ...search.value, excel: 1,store_id:$route.query.store_id, }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        window.open(res.data.file_url);
      }
    };
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      changTime,
      inputSelect,
      exportTable,
    };
  },
};
</script>